import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import '../styles/TermsAndPrivacyModal.css';

export default function TermsAndPrivacyModal({ isOpen, onClose, onAccept }) {
  const { lang } = useLanguage();

  if (!isOpen) return null;

  return (
    <div className="terms-modal-overlay" onClick={onClose} role="dialog" aria-modal="true">
      <div className="terms-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="terms-modal-header">
          <div className="terms-header-branding">
            <img src="/logo.png" alt="Turon University" className="terms-header-logo" />
            <div>
              <h3 className="terms-title">
                {lang === 'ru' ? 'Портал Университета Турон' : lang === 'en' ? 'Turon University Portal' : 'Turon Universiteti Portali'}
              </h3>
              <span className="terms-subtitle">
                {lang === 'ru'
                  ? 'Условия использования и Политика конфиденциальности (Официальный регламент)'
                  : lang === 'en'
                  ? 'Terms of Service and Privacy Policy (Official Regulation)'
                  : 'Foydalanish şartlari va Maxfiylik siyosati (Rasmiy nizom)'}
              </span>
            </div>
          </div>
          <button className="terms-close-btn" onClick={onClose} aria-label="Yopish">✕</button>
        </div>

        <div className="terms-modal-body">
          {lang === 'ru' ? (
            <>
              <section className="terms-section">
                <h4>1. Общие положения и цели Портала</h4>
                <p>
                  Настоящий Регламент определяет порядок использования «Портала интерактивных услуг» Университета Турон, права и обязанности сторон, а также принципы защиты персональных данных пользователей.
                </p>
                <p>
                  Портал служит целям цифровизации, обеспечения открытости и прозрачности процессов послевузовского образования (базовая докторантура, докторантура, стажеры-исследователи), квалификационных экзаменов и контроля качества образования.
                </p>
              </section>

              <section className="terms-section">
                <h4>2. Учетная запись пользователя и безопасность</h4>
                <ul>
                  <li>
                    <strong>Достоверность данных:</strong> Пользователь обязуется предоставлять подлинные Ф.И.О., контактные данные, документы, удостоверяющие личность, и научные материалы.
                  </li>
                  <li>
                    <strong>Безопасность учетной записи:</strong> Пользователь несет личную ответственность за сохранение конфиденциальности пароля и доступа к личному кабинету.
                  </li>
                  <li>
                    <strong>Подтверждение через Email:</strong> В соответствии с международными стандартами кибербезопасности, при регистрации направляется код подтверждения, после ввода которого учетная запись активируется.
                  </li>
                </ul>
              </section>

              <section className="terms-section">
                <h4>3. Защита персональных данных (Политика конфиденциальности)</h4>
                <p>
                  Университет Турон строго соблюдает Закон Республики Узбекистан «О персональных данных» № ЗРУ-547 от 02.07.2019 г. и требования регламента GDPR:
                </p>
                <ul>
                  <li>
                    <strong>Собираемые данные:</strong> Ф.И.О., ПИНФЛ, паспортные данные, телефон, email, место работы/учебы, дипломы, темы исследований, квитанции об оплате.
                  </li>
                  <li>
                    <strong>Цели обработки:</strong> Рассмотрение заявлений, организация квалификационных экзаменов, формирование официальных ведомостей и отчетность перед ВАК.
                  </li>
                  <li>
                    <strong>Гарантия нераспространения:</strong> Данные пользователей никогда не передаются и не продаются третьим лицам в коммерческих целях.
                  </li>
                  <li>
                    <strong>Шифрование:</strong> Все данные передаются по зашифрованным протоколам SSL/TLS (HTTPS) и хранятся на защищенных серверах.
                  </li>
                </ul>
              </section>

              <section className="terms-section">
                <h4>4. Квалификационные экзамены и оплата</h4>
                <ul>
                  <li>
                    Для соискателей из других вузов и научных учреждений сбор за сдачу квалификационного экзамена установлен в размере 1 Базовой расчетной величины (1 БРВ).
                  </li>
                  <li>
                    Для докторантов и исследователей самого Университета Турон услуга предоставляется бесплатно.
                  </li>
                </ul>
              </section>

              <section className="terms-section">
                <h4>5. Права пользователя</h4>
                <p>
                  Пользователь имеет право на ознакомление со своими персональными данными, исправление неточностей или удаление учетной записи при наличии законных оснований путем обращения к администрации.
                </p>
              </section>
            </>
          ) : lang === 'en' ? (
            <>
              <section className="terms-section">
                <h4>1. General Provisions and Portal Purpose</h4>
                <p>
                  These Regulations govern the terms of use of Turon University's "Interactive Services Portal", outlining the rights and obligations of the parties and the principles of personal data protection.
                </p>
                <p>
                  The Portal serves to digitize and provide transparency for postgraduate education (doctoral studies, internships), qualifying examinations, and academic quality assurance.
                </p>
              </section>

              <section className="terms-section">
                <h4>2. User Account and Security Obligations</h4>
                <ul>
                  <li>
                    <strong>Data Accuracy:</strong> The user agrees to provide accurate and authentic personal details, contact information, identity documents, and academic records.
                  </li>
                  <li>
                    <strong>Account Security:</strong> The user is personally responsible for safeguarding account credentials and password confidentiality.
                  </li>
                  <li>
                    <strong>Email Verification:</strong> In compliance with cybersecurity standards, accounts must be verified via confirmation code or email link prior to full activation.
                  </li>
                </ul>
              </section>

              <section className="terms-section">
                <h4>3. Personal Data Protection (Privacy Policy)</h4>
                <p>
                  Turon University strictly complies with the Law of the Republic of Uzbekistan "On Personal Data" and GDPR privacy principles:
                </p>
                <ul>
                  <li>
                    <strong>Data Collected:</strong> Full name, PINFL, passport/ID details, phone number, email, affiliation, diploma records, dissertation topics, payment receipts.
                  </li>
                  <li>
                    <strong>Purpose of Use:</strong> Processing exam applications, scheduling examinations, generating official transcripts, and regulatory reporting to the Higher Attestation Commission.
                  </li>
                  <li>
                    <strong>Non-Disclosure Guarantee:</strong> User data is never sold or disclosed to third parties for commercial or advertising purposes.
                  </li>
                  <li>
                    <strong>Encryption:</strong> All data is securely transmitted via SSL/TLS (HTTPS) encrypted channels and maintained on protected servers.
                  </li>
                </ul>
              </section>

              <section className="terms-section">
                <h4>4. Qualifying Exams and Service Fees</h4>
                <ul>
                  <li>
                    For applicants from other higher education or scientific institutions, the exam administration fee is fixed at 1 Base Calculation Amount (1 BRV).
                  </li>
                  <li>
                    For internal doctoral candidates and researchers of Turon University, the exam service is completely free of charge.
                  </li>
                </ul>
              </section>

              <section className="terms-section">
                <h4>5. User Rights</h4>
                <p>
                  Users maintain the right to inspect their personal records, request corrections, or request account erasure by submitting a formal request to university administration.
                </p>
              </section>
            </>
          ) : (
            <>
              <section className="terms-section">
                <h4>1. Umumiy qoidalar va Portal maqsadi</h4>
                <p>
                  Uşbu Nizom Turon universitetining "Interaktiv xizmatlar portali" (keyingi õrinlarda — Portal)dan foydalaniş tartibi, tomonlarning huquq va majburiyatlari hamda foydalanuvçilarning şaxsga doir maʼlumotlarini himoya qiliş tamoyillarini belgilaydi.
                </p>
                <p>
                  Portal oliy taʼlimdan keyingi taʼlim (tayanç doktorantura, doktorantura, stajyor-tadqiqotçilik), malakaviy imtihonlar, taʼlim sifatini nazorat qiliş va boşqa universitet xizmatlarini raqamlaştiriş, oçiqlik va şaffoflikni taʼminlaş maqsadida xizmat qiladi.
                </p>
              </section>

              <section className="terms-section">
                <h4>2. Foydalanuvçining hisobi va xavfsizlik majburiyatlari</h4>
                <ul>
                  <li>
                    <strong>Tõğri va haqqoniy maʼlumotlar:</strong> Foydalanuvçi Portalda rõyxatdan õtişda va arizalarni topşirişda õzining haqiqiy F.I.Ş, elektron poçta manzili, şaxsni tasdiqlovçi maʼlumotlari va ilmiy hujjatlarini taqdim etiş majburiyatini oladi. Soxta maʼlumot kiritiş qonunçilikka muvofiq arizani bekor qilişga olib keladi.
                  </li>
                  <li>
                    <strong>Hisob xavfsizligi:</strong> Foydalanuvçi õz paroli va kiriş maʼlumotlarining maxfiyligini saqlaş uçun şaxsan javobgardir. Şaxsiy kabinet orqali amalga oşirilgan barça arizalar va murojaatlar foydalanuvçining õzi tomonidan bajarilgan deb hisoblanadi.
                  </li>
                  <li>
                    <strong>Email orqali tasdiqlaş:</strong> Xalqaro kiberxavfsizlik talablariga asosan, yangi hisob yaratilganda kõrsatilgan elektron poçta manziliga tasdiqlaş xabari yuboriladi va hisob faqatgina tasdiqlangandan sõng tõliq faollaşadi.
                  </li>
                </ul>
              </section>

              <section className="terms-section">
                <h4>3. Şaxsga doir maʼlumotlarni himoya qiliş (Maxfiylik siyosati)</h4>
                <p>
                  Turon universiteti Õzbekiston Respublikasining 2019-yil 2-iyuldagi "Şaxsga doir maʼlumotlar tõğrisida"gi ÕRQ-547-sonli Qonuni hamda Yevropa Ittifoqining Şaxsiy maʼlumotlarni himoya qiliş umumiy reglamenti (GDPR) talablariga tõliq rioya qiladi:
                </p>
                <ul>
                  <li>
                    <strong>Qanday maʼlumotlar tõplanadi:</strong> Familiya, ism, şarif, JŞŞIR, pasport/ID-karta seriyasi va raqami, telefon raqami, elektron poçta manzili, iş/õqiş joyi, diplom va ilmiy mavzular, tõlov kvitansiyalari hamda tizim xavfsizligini taʼminlaş uçun texnik maʼlumotlar.
                  </li>
                  <li>
                    <strong>Maʼlumotlardan foydalaniş maqsadi:</strong> Foydalanuvçi topşirgan imtihon arizalarini kõrib çiqiş, malakaviy imtihonlarni taşkil etiş, rasmiy qaydnomalarni şakllantiriş va OAK talablariga asosan hisobotlarni yuritiş.
                  </li>
                  <li>
                    <strong>Uçinçi şaxslarga berilmaslik kafolati:</strong> Foydalanuvçilarning şaxsiy maʼlumotlari tijoriy yoki reklama maqsadlarida heç qaçon uçinçi şaxslarga berilmaydi va sotilmaydi.
                  </li>
                  <li>
                    <strong>Şifrlaş va xavfsizlik çoralari:</strong> Barça maʼlumotlar va yuklangan hujjatlar SSL/TLS (HTTPS) şifrlangan aloqa kanallari orqali uzatiladi va himoyalangan server infratuzilmasida saqlanadi.
                  </li>
                </ul>
              </section>

              <section className="terms-section">
                <h4>4. Malakaviy imtihonlar va xizmat tõlovlari tartibi</h4>
                <ul>
                  <li>
                    Turon universiteti Kengaşining tegişli qaroriga asosan, boşqa oliy taʼlim va ilmiy-tadqiqot muassasalaridan ariza topşirgan talabgorlar uçun malakaviy imtihon tõlovi Bazaviy hisoblaş miqdorining 1 baravari (BHM 1 baravari) etib belgilangan.
                  </li>
                  <li>
                    Turon universitetining õz doktorantlari va mustaqil izlanuvçilari uçun malakaviy imtihon xizmati mutlaqo bepul kõrsatiladi.
                  </li>
                </ul>
              </section>

              <section className="terms-section">
                <h4>5. Foydalanuvçining maʼlumotlarni õçiriş va tuzatiş huquqi</h4>
                <p>
                  Har bir foydalanuvçi õz şaxsiy maʼlumotlari bilan tanişiş, xatoliklarni tuzatişni talab qiliş yoki qonuniy asoslar mavjud bõlganda hisobni va şaxsiy maʼlumotlarni tizimdan tõliq õçirişni sõraş huquqiga ega.
                </p>
              </section>
            </>
          )}

          <section className="terms-section">
            <h4>
              {lang === 'ru' ? '6. Контакты и реквизиты' : lang === 'en' ? '6. Contact & Official Info' : '6. Aloqa va vakolatli maʼlumotlar'}
            </h4>
            <div className="terms-contacts-box">
              <div><strong>🏛️ {lang === 'ru' ? 'Организация:' : lang === 'en' ? 'Institution:' : 'Muassasa:'}</strong> Turon universiteti</div>
              <div><strong>📍 {lang === 'ru' ? 'Адрес:' : lang === 'en' ? 'Address:' : 'Manzil:'}</strong> {lang === 'ru' ? 'г. Карши, ул. Насаф, 1/14' : lang === 'en' ? 'Karshi city, Nasaf str., 1/14' : 'Õzbekiston Respublikasi, Qarşi şahri, Nasaf kõçasi, 1/14-uy'}</div>
              <div><strong>📞 {lang === 'ru' ? 'Контактный телефон:' : lang === 'en' ? 'Contact Center:' : 'Aloqa markazi:'}</strong> +998 (75) 220-00-25</div>
              <div><strong>✉️ Email:</strong> turonuniversity@gmail.com</div>
              <div><strong>🌐 Web:</strong> turonuniversity.uz / turonservices.duckdns.org</div>
            </div>
          </section>
        </div>

        <div className="terms-modal-footer">
          <button type="button" className="btn-terms-secondary" onClick={onClose}>
            {lang === 'ru' ? 'Закрыть' : lang === 'en' ? 'Close' : 'Yopiş'}
          </button>
          {onAccept && (
            <button type="button" className="btn-terms-primary" onClick={onAccept}>
              {lang === 'ru' ? '✓ Ознакомлен и согласен' : lang === 'en' ? '✓ I have read and agree' : '✓ Tanişdim va qabul qilaman'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
